<script>
  import Letter from "./Letter.svelte";
  import PlayPause from "./PlayPause.svelte";

  export let letters;
  export let alphabet;
  export let select;
  export let recitate;
  export let isRecitating;
  export let currentIndex;
</script>

<style>
  main {
    position: relative;
    margin: 0 auto;
    padding: 2vh;
    max-width: 66vh;
    height: 100vh;
    background-color: black;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(11, 1fr);
    grid-gap: 2vh;
    grid-template-areas:
      "C11 C21 C31 C41 C51 C61"
      "C12 C22 C32 C42 . ."
      "C13 C23 C33 C43 C53 C63"
      "C14 C24 C34 C44 C54 ."
      "C15 C25 C35 C45 C55 ."
      "C16 C26 C36 C46 C56 ."
      "C17 C27 C37 C47 C57 ."
      "C18 C28 C38 C48 C58 ."
      "C19 C29 C39 C49 . ."
      "C110 C210 C310 . . ."
      "C111 . . . . .";
    user-select: none;
  }
</style>

<main>
  {#each letters as letter}
    <Letter {letter} {alphabet} {select} {currentIndex} />
  {/each}
  <PlayPause on:click={recitate} {isRecitating} />
</main>
